export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "loading_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading ..."])}
      },
      "fr": {
        "loading_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chargement ..."])}
      }
    }
  })
}